import type { ShareTask } from '../ShareTask';
import type { ShareContent } from '../Types';

import { ShareContentSource } from '../Types';

import { getApp } from '@egr/xbox/base-app/App';
import { getAllBasketIds } from '@egr/xbox/egr-gui-utils/items/getAllBasketIds';
import { getValideExportModels } from '@egr/xbox/pcon-catalog/SourceTracker';
import { assert } from '@egr/xbox/utils/Debug';
import { SessionExportFormat } from '@egr/xbox/utils/FileFormats';
import { AsyncIteratorToArray } from '@egr/xbox/utils/Promise';

import { isNotNullOrEmpty } from '@easterngraphics/wcf/modules/utils/string';

export async function *shareObxHandler(shareTask: ShareTask): AsyncIterableIterator<ShareContent> {
    const app = await getApp();
    const itemIds = shareTask.itemIds.length === 0 ? Array.from(getAllBasketIds(await AsyncIteratorToArray(getValideExportModels(app)))) : shareTask.itemIds;
    const obxUrl: string = await app.eaiwsBaskets.session.basket.copy(itemIds, null, null);

    if (assert(isNotNullOrEmpty(obxUrl), 'obx url should not be empty')) {
        shareTask.telemetryEventQueue?.addPartialEvent({name: 'obx'});

        const filename = shareTask.shareFilenameManager.getFilename(SessionExportFormat.OBX.extension);

        yield {
            source: ShareContentSource.REMOTE_URL,
            content: `${obxUrl}?contentDisposition=attachment&filename=${encodeURIComponent(filename)}`,
            filename,
            filetype: SessionExportFormat.OBX,
            shareFormatKey: 'OBX'
        };
    }
}